import React, { useEffect, useState } from 'react'
import Layout from '../layout-tank/layout'
import styles from './alert-management.module.css'
import AssetView, {
  AlertViewContext,
} from '../alerts/alert-info-view/alertView'
import { DEVICE_STATUS_ENUM } from '../../../services/device'
import DeviceList from '../alerts/device-list/devicetList.component'

export default function AlertManagement() {
  const [viewAlert, setViewAlert] = useState(false)
  const [assetData, setAssetData] = useState(false)

  useEffect(() => {
    setViewAlert(false)
  }, [])

  return (
    <Layout>
      <AlertViewContext.Provider
        value={{
          viewAlert,
          setViewAlert,
          assetData,
          setAssetData,
        }}
      >
        <div className={styles.container}>
          {viewAlert ? (
            <AssetView />
          ) : (
            <>
              <DeviceList
                className={styles.list}
                status={DEVICE_STATUS_ENUM.ALL}
              />
            </>
          )}
        </div>
      </AlertViewContext.Provider>
    </Layout>
  )
}
